import { useCallback, useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';

export default function useGalleryPurchaseRejection() {
  const { state } = useStateHandler();
  const t = useTranslations('common.shared.artwork_view.purchase_rejection');
  const [open, setOpen] = useState(false);
  const show = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  const viewer = state?.user_session ?? {};
  const isGalleryAccount = String(viewer.user_type ?? viewer.__t ?? '').trim().toLowerCase() === 'gallery';

  return {
    isGalleryAccount,
    open,
    show,
    close,
    description: t('gallery_account'),
  };
}
